import React from "react";
import styles from "./Ideas.module.scss";
import { Link } from "react-router";

const Ideas: React.FC = () => {
  return (
    <section className={styles.ideas}>
      <div className="container">
        <div className={styles.body}>
          <h2 className={styles.title}>Фурнитура для ваших идей</h2>
          <p className={styles.text}>
            Вся фурнитура в одном месте. Всегда в наличии нитки, <br /> молнии, ленты, крючки для одежды и всё, что вам необходимо
            для комфортной работы!
          </p>
          <div className={styles.button}>
            <Link to="/catalog">
              <button>Перейти в каталог</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ideas;
